import { ESdChangeReason, IDatabaseColumnModel } from "@kuika/kuika-cl-model";
import {
  ECardinality,
  EManagedDbUpdateWhereConditionOperator,
  ESymbolCategory,
  IAction,
  IManagedDbWhereConditionModel,
  ISymbol
} from "@kuika/kuika-cl-model/src/models/builder.dtos";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import KuikaButton from "../../../ui-kit/kuika-button/kuika-button";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../ui-kit/kuika-selectbox/kuika-selectbox";
import { SymbolPicker } from "./symbol-picker";

export interface IManagedDbWhereConditionState {}

export interface IManagedDbWhereConditionProps {
  action: IAction;
  conditionModel: IManagedDbWhereConditionModel;
  tableColumns: any[];
  updateConditionModel: (updatedCondition: IManagedDbWhereConditionModel) => void;
  removeCondition: () => void;
}

class ManagedDbWhereCondition extends PureSdComponent<
  IManagedDbWhereConditionProps & IWithSDProps,
  IManagedDbWhereConditionState
> {
  constructor(props: IManagedDbWhereConditionProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  handleSelectColumn = (e: string): void => {
    const conditionModel = this.props.conditionModel;
    const sqlDataType = this.props.tableColumns.find((x) => x.name === e).sqlDataType;
    const newTypeName = KMainFunctions.getTypeNameBySqlDataType(sqlDataType);
    if (newTypeName !== conditionModel.typeName) {
      conditionModel.typeName = newTypeName;
      conditionModel.symbol = {
        category: ESymbolCategory.fixed,
        fixedValue: ""
      } as ISymbol;
    }

    conditionModel.colName = e;

    this.props.updateConditionModel(conditionModel);
  };

  handleSelectCondition = (e: EManagedDbUpdateWhereConditionOperator): void => {
    const conditionModel = this.props.conditionModel;
    conditionModel.conditionOperator = e;
    this.props.updateConditionModel(conditionModel);
  };

  handleSelectSymbol = (symbol: ISymbol): void => {
    const conditionModel = this.props.conditionModel;
    conditionModel.symbol = symbol;
    this.props.updateConditionModel(conditionModel);
  };

  render() {
    const { conditionModel, tableColumns } = this.props;
    const columnOptions: KuikaSelectboxOption[] = tableColumns.map(
      (column: IDatabaseColumnModel): KuikaSelectboxOption => ({
        key: column.name,
        value: column.name,
        label: column.name
      })
    );
    const conditionOptions: KuikaSelectboxOption[] = Object.keys(EManagedDbUpdateWhereConditionOperator).map(
      (conditionOperator: string): KuikaSelectboxOption => ({
        key: conditionOperator,
        value: conditionOperator,
        label: conditionOperator
      })
    );

    return (
      <>
        <div style={{ backgroundColor: "var(--dark-0)" }}>
          <KuikaSelectbox
            placeholder="Select Column"
            className="kuika__action-parameters__item-select"
            onChange={this.handleSelectColumn}
            dropdownMatchSelectWidth={false}
            value={conditionModel.colName ?? null}
            options={columnOptions}
          />

          <KuikaSelectbox
            placeholder="Select Condition"
            className="kuika__action-parameters__item-select"
            onChange={this.handleSelectCondition}
            dropdownMatchSelectWidth={false}
            value={conditionModel.conditionOperator}
            options={conditionOptions}
          />

          <SymbolPicker
            action={this.props.action}
            changeType="onBlur"
            symbol={conditionModel.symbol}
            valueType={conditionModel.typeName}
            targetCardinality={ECardinality.One}
            onSelectedSymbol={(symbol: ISymbol) => this.handleSelectSymbol(symbol)}
          />
          <div className="kuika_styling_typography_footer" style={{ padding: "4px 6px", marginTop: 0 }}>
            <KuikaButton type="text" size="sm" onClick={this.props.removeCondition}>
              Remove
            </KuikaButton>
          </div>
        </div>
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.DiActionUpdated ||
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.WFStepMappingChange ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock
    ) {
      return true;
    }
    return false;
  };
}

const managedDbWhereCondition = withSD<IManagedDbWhereConditionProps>(ManagedDbWhereCondition);
export { managedDbWhereCondition as ManagedDbWhereCondition };
